import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    let title = "Default Title"; // Default title
    const titles = {
      "/": "Login",
      "/login": "Login",
      "/admin/dashboard": "Dashboard",
      "/admin/add-student": "Add Student",
      "/admin/view-student": "View Student",
      "/admin/student-billing": "Student Billing",
      "/admin/all-billing": "Student Billing",
      "/admin/staff/wallet": "Transfer Wallet",
      "/admin/wallet": "Transfer Wallet",
      "/admin/wallet-history": "Wallet History",
      "/admin/notice": "Notice",
      "/admin/product-category": "Add Category",
      "/admin/product-sub-category": "Add Sub Category",
      "/admin/product": "Add Product",
      "/admin/product-variant": "Add Product Variant",
      "/admin/stock-add": "Add Stock",
      "/admin/product-bundle/create": "Add Stock",
      "/admin/product-bundle/list": "List Stock",
      "/admin/product-bundle/view/:id": "View Product Variant",
      "/admin/subject-add": "Add Subject",
      "/admin/subject-class/assign": "Assign Subject",
      "/admin/teacher-add": "Add Teacher",
      "/admin/teacher-subject/assign": "Assign Subject to Teacher",
    };

    // Check for exact match
    if (titles[location.pathname]) {
      title = titles[location.pathname];
    } 
    // Handle dynamic route
    else if (location.pathname.startsWith("/admin/view-student-details/")) {
      title = "View Student Details";
    }

    document.title = title;
  }, [location]);

  return null; // No UI needed
};

export default PageTitle;
